@if (show()) {
  <div class="card-body">
    <h4>Get Started</h4>
    <ol class="mb-0">
      @for (itinerary of itineraries(); track $index; let last = $last) {
        <li
          [class]="itinerary.progress"
          (click)="resumeSkippedItinerary(itinerary)"
        >
          {{ itinerary.name }}
        </li>
        @if (!last) {
          <div class="connector"></div>
        }
      }
    </ol>
  </div>
}
